var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailVerficationIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.62,
    height: 11.874,
    viewBox: "0 0 11.62 11.874",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10151",
    "data-name": "Group 10151",
    transform: "translate(-148.756 -189.927)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Email_3039394",
    transform: "translate(148.756 189.927)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10150",
    "data-name": "Group 10150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8909",
    "data-name": "Path 8909",
    d: "M14.495,19.874H9.534a.851.851,0,0,1-.849-.849V13.361a1.256,1.256,0,0,1,.464-1.083l.445-.38v1.12a.412.412,0,0,0,.175.344l.2.149L13.988,16.5A.839.839,0,0,0,15,16.5l4.014-2.988.2-.149a.413.413,0,0,0,.176-.344V11.9l.445.38a1.257,1.257,0,0,1,.464,1.083v5.664a.851.851,0,0,1-.849.849H14.495ZM10.794,9.02h7.4a.778.778,0,0,1,.776.776v3.223l-.557.4V9.82a.213.213,0,0,0-.212-.212H10.787a.213.213,0,0,0-.212.212v3.6l-.557-.4V9.8a.778.778,0,0,1,.776-.776Zm2.67-.424.315-.269a.948.948,0,0,1,1.431,0l.315.269Z",
    transform: "translate(-8.685 -8)",
    fill: "currentColor",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8910",
    "data-name": "Path 8910",
    d: "M0,1.034l.5.751L2.918,0",
    transform: "matrix(0.978, -0.208, 0.208, 0.978, 152.954, 193.939)",
    fill: "none",
    stroke: "#505f7b",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVerficationIco);
export default __webpack_public_path__ + "static/media/emailVerfication_ico.b96ad103.svg";
export { ForwardRef as ReactComponent };